// Copyright Epic Games, Inc. All Rights Reserved.

export default {
  messages: {
    "error.errorCode": "Foutcode:",
    "error.search": "Bekijk onze knowledgebase voor meer informatie",
    dismiss: "sluiten",
    "installation.title": "",
    "cancelation.button": "Annuleren",
  },
  errorCodes: {
    "EOS-UI-NF": {
      title: "Initialisatie mislukt",
      description:
        "We kunnen de pagina niet weergeven. Neem contact op met de ondersteuning.",
    },
    "EOS-UI-UE": {
      title: "Er is iets misgegaan",
      description:
        "Er is iets misgegaan. Neem contact op met de ondersteuning.",
    },
    "EOS-IN-BC": {
      title: "Installatie mislukt",
      description:
        "We kunnen de status van de installatie niet laten zien. Neem contact op met de ondersteuning.",
    },
    "EOS-IN-UE": {
      title: "Installatie mislukt",
      description:
        "Er is iets misgegaan. Neem contact op met de ondersteuning.",
    },
    "EOS-IN-FF": {
      title: "Installatie mislukt",
      description:
        "We kunnen geen verbinding maken met Epic Online Services. Neem contact op met de ondersteuning.",
    },
    "EOS-IN-FF-*": {
      title: "Installatie mislukt",
      description:
        "We kunnen het verzoek aan Epic Online Services niet verzenden. Neem contact op met de ondersteuning.",
    },
    fallback: {
      title: "Er is iets misgegaan",
      description:
        "Er is iets misgegaan. Neem contact op met de ondersteuning.",
    },
  },
};
